import React from 'react'
import { Select, Spin } from 'antd'
import * as _ from 'lodash'
import api from '../../common/api'
import { setSuppliers } from '../../redux-store/actions/data-actions'
import { connect } from 'react-redux'


class SupplierSelect extends React.Component {
  state = {
    fetching: false,
    data: [],
    indexUpdater: 0
  };


  constructor(props, context) {
    super(props, context)

    this.fetchSupplier = this.fetchSupplier.bind(this);
    this.handleChange = _.debounce(this.handleChange.bind(this), 800);
  }

  componentDidMount() {
    if (_.isArray(this.props.syncData)) {
      this.setState({data: this.props.syncData});
    }

    if (_.size(this.state.data) === 0 && !_.isNil(this.props.defaultValue)) {
      api.suppliers.search(this.props.defaultValue).then(response => {
        if (this.props.searchDataUpdate) {
          this.props.searchDataUpdate(response.data);
        }
        this.setState({data: response.data, fetching: false});

        this.handleChange(this.props.defaultValue);
      }).catch(err => {
        console.error(err);
        this.setState({fetching: false, data: []});
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.syncData !== this.props.syncData && _.isArray(this.props.syncData)) {
      this.setState({data: this.props.syncData});
    }

    if (prevState.data !== this.state.data) {
      this.props.setSuppliers(this.state.data);
    }
  }

  fetchSupplier = (value) => {
    if (_.size(value) < 3) {
      return;
    }

    this.setState({
      data: [],
      fetching: true
    });

    api.suppliers.search(value).then(response => {
      if (this.props.searchDataUpdate) {
        this.props.searchDataUpdate(response.data);
      }
      this.setState({data: response.data, fetching: false});
    }).catch(err => {
      console.error(err);
      this.setState({fetching: false, data: []});
    });
  };

  handleChange = (value) => {
    this.setState({
      fetching: false
    });

    this.props.onChange(value);
  }

  render() {
    const { disabled, defaultValue, value } = this.props;
    const { fetching, data } = this.state;

    return (
      <Select
        showSearch
        allowClear
        filterOption={false}
        disabled={disabled}
        style={{ width: '100%' }}
        placeholder="Seleziona il fornitore"
        onChange={this.handleChange}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        value={value}
        onSearch={this.fetchSupplier}
        defaultValue={defaultValue}>
        {_.map(data, (el, index) => (
          <Select.Option key={index} value={el.num_foucom}>
            {el.description}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

const mapStateToProps = state => {
  return {}
};

const mapDispatchToProps = {
  setSuppliers
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSelect);



// WEBPACK FOOTER //
// ./src/components/SupplierSelect/index.js